import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { BP_PHONE } from "./common";

document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);
  let mm = gsap.matchMedia();
  // -------------------------------
  const sectionMain = document.getElementById("main-anim-js");
  const header = document.querySelector(".header-js");

  if (sectionMain) {
    const container = sectionMain.querySelector(".main-anim-container-js"),
      title = sectionMain.querySelector(".main-anim-title-js"),
      desc = sectionMain.querySelector(".main-anim-desc-js"),
      img = sectionMain.querySelector(".main-anim-img-js"),
      overlay = sectionMain.querySelector(".main-anim-overlay-js"),
      video = sectionMain.querySelector(".main-anim-img-js video");
    let playPromise;

    video && (playPromise = video.play());

    // video.addEventListener("pointermove", (event) => {
    // 	if (video && video.paused) {
    // 	playPromise = video.play();
    // 	}
    // });

    if (!window.scrollY) {
      const html = document.documentElement;
      html.style.overflow = "hidden";
      mm.add(
        {
          isDesktop: `(min-width: ${BP_PHONE + 1}px)`,
          isMobile: `(max-width: ${BP_PHONE}px)`,
        },
        (context) => {
          let { isMobile, isDesktop } = context.conditions;

          let tl1 = gsap.timeline({
            duration: 4,
            delay: 1,
            onComplete: () => {
              html.style.overflow = "";
            },
          });

          tl1
            .fromTo(
              ".logo-home-js",
              {
                y: window.innerHeight * 0.35 + 50,
                scale: isMobile ? 2.5 : 3.5,
              },
              { y: 0, scale: 1 },
              0
            )
            .fromTo(title, { autoAlpha: 0 }, { autoAlpha: 1 }, 0.6)
            .fromTo(desc, { y: 200 }, { y: 0 }, 0.3)
            .fromTo(
              img,
              { yPercent: 70, scale: 0.7, ease: "none" },
              { yPercent: 0, scale: 1, ease: "none" },
              0
            )
            .fromTo(
              overlay,
              { opacity: 0, ease: "none" },
              { opacity: 0.3, ease: "none" },
              0
            );
        }
      );
    }

    const tl2 = gsap.timeline({ paused: true });
    tl2
      .to(title, { autoAlpha: 0 }, 0)
      .to(desc, { autoAlpha: 0 }, 0)
      .to(img, { yPercent: 20, scale: 1.4, ease: "none" }, 0)
      .to(overlay, { opacity: 0.9, ease: "none" }, 0);

    const tlHeaderMain = gsap.timeline({ paused: true });
    tlHeaderMain.to(header, { autoAlpha: 0 });

    const transformer = gsap.utils.pipe(gsap.utils.mapRange(0, 0.2, 0, 1));

    ScrollTrigger.create({
      trigger: sectionMain,
      start: "top top",
      end: "bottom top",
      scrub: 0.1,
      fastScrollEnd: true,
      invalidateOnRefresh: true,
      // markers: true,
      onUpdate: ({ progress }) => {
        tl2.progress(progress);
        tlHeaderMain.progress(transformer(progress));
      },
      onEnterBack: () => {
        gsap.set(header, { autoAlpha: 0 });
        if (video && video.paused) {
          playPromise = video.play();
        }
      },
      onEnter: () => {
        if (video && video.paused) {
          playPromise = video.play();
        }
      },
      onLeave: () => {
        if (video) {
          if (playPromise !== undefined) {
            playPromise
              .then((_) => {
                video.pause();
              })
              .catch((error) => {});
          }
        }
      },
    });
    // -------------------------------
  }
});
